export const projects = [
  {
    name: "Home Automation",
    src: "./assets/images/projects/HA.jpg",
    desc: "An automatic room light system using Arduino uno, Bluetooth module, Ultrasonic Sensors, 5V relay module, 16x2 LCD Display programmed in C language.",
    url: "https://youtu.be/XIkinSavEQE",
  },

  {
    name: "Your HR",
    src: "./assets/images/projects/HR.jpg",
    desc: "Developed a Django-powered job portal enabling users to register as either job applicants or job providers.",
    url: "https://gaurav16.pythonanywhere.com/jobs/",
  },
  {
    name: "Space Invaders",
    src: "./assets/images/projects/SI.jpg",
    desc: "Created an interactive balloon shooter game using JavaScript, showcasing my programming skills and ability to develop engaging user experiences.",
    url: "https://gaurav507.github.io/Balloon-shooter-game/",
  },
  {
    name: "Weather App",
    src: "./assets/images/projects/weather.jpg",
    desc: "Utilized the OpenWeatherMap API to retrieve and display weather reports for a specified location by name.",
    url: "https://gaurav507.github.io/Weather-App/",
  },
  {
    name: "Django-Blog",
    src: "./assets/images/projects/blog.jpg",
    desc: "Designed and implemented a Django-based blog website that allows users to establish and manage their profiles.",
    url: "http://gaurav1603.pythonanywhere.com/",
  },
];